import React, { memo, Fragment } from 'react'
// import includes from 'ramda/src/includes'
// import pluck from 'ramda/src/pluck'
import classNames from 'classnames'
import goToPledgeProjectHandler from 'root/src/client/logic/project/handlers/goToPledgeProjectHandler'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import { faTwitch } from '@fortawesome/free-brands-svg-icons/faTwitch'
import Button from 'root/src/client/web/base/Button'
import {
	notConnected, connectedNotClaimed,
	creatorRejectedStatus,
	notEligible,
	videoApprovedNotCreator,
	accepted,
} from 'root/src/shared/constants/projectAcceptanceStatuses'
import { REJECT_PROJECT_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import {
	// REMOVE_DARE,
	ADD_FEATURED_DARE, DELETE_FEATURED_DARE } from 'root/src/shared/descriptions/endpoints/endpointIds'
// import {
// 	VIEW_CREATOR_DATA_ROUTE_ID, VIEW_YT_CREATOR_DATA_ROUTE_ID,
// } from 'root/src/shared/descriptions/routes/routeIds'
// import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import ClaimButton from './ClaimButton'

export default memo(({
	classes, projectUrl, assignees, projectAcceptanceStatus, redirectAndPrePopulate,
	displayModal, isAuthenticated, oauthAuthenticate, setInput, projectDeliveries,
	brandProduct, claimSponsoredProject, reportCtaClick, projectId, /* userData,  */apiRequest,
	isAdmin, isFeatured, timeLeft, landingShortUrl,
}) => {
	const renderPledgeButton = [
		notConnected, notEligible, videoApprovedNotCreator, creatorRejectedStatus,
	].indexOf(projectAcceptanceStatus) > -1
	const renderRejectButton = [connectedNotClaimed]
		.indexOf(projectAcceptanceStatus) > -1
		|| [accepted].indexOf(projectAcceptanceStatus) > -1
	// const isAssignee =	includes(
	// 	userData?.creatorData?.platformId,
	// 	pluck('platformId', assignees),
	// ) && !renderRejectButton
	const isExpiredProject = timeLeft <= 0

	return (
		<Fragment>
			{renderPledgeButton && !brandProduct && (
				<div className={classNames('flex', classes.actionButtonContainer, classes.autoSize)}>
					<div className={classes.buttonTextWrapper}>Pledge to Dare</div>
					<div className={classes.buttonWrapper}>
						<Button
							onClick={() => goToPledgeProjectHandler({ recordId: projectUrl })
							}
						>
							Pledge
						</Button>
					</div>
				</div>
			)}
			{renderPledgeButton && brandProduct && (
				<div className={classNames('flex', classes.actionButtonContainer)}>
					<div className={classes.buttonTextWrapper} />
					<div className={classes.buttonWrapper}>
						<a
							target="_blank"
							rel="noopener noreferrer"
							href={addHttpsProtocol(landingShortUrl || brandProduct.url)}
							onClick={() => reportCtaClick(projectId)}
							className={classes.pointer}
						>
							<Button>
								{brandProduct.cta}
							</Button>
						</a>
					</div>
				</div>
			)}
			{!isExpiredProject && (
				<div className={classNames('flex', classes.actionButtonContainer)}>
					<div className={projectAcceptanceStatus !== 'accepted' ? classes.fullSize : undefined}>
						<ClaimButton
							projectAcceptanceStatus={projectAcceptanceStatus}
							projectUrl={projectUrl}
							assignees={assignees}
							isAuthenticated={isAuthenticated}
							buttonTextWrapperClass={classes.buttonTextWrapper}
							pendingVideoClass={classes.pendingVideo}
							buttonWrapperClass={classes.buttonWrapper}
							oauthAuthenticate={oauthAuthenticate}
							icon={faTwitch}
							brandProduct={brandProduct}
							claimSponsoredProject={claimSponsoredProject}
							setInput={setInput}
							projectDeliveries={projectDeliveries}
							redirectAndPrePopulate={redirectAndPrePopulate}
						/>
					</div>
				</div>
			)}
			{renderRejectButton
				&& (
					<div className={classNames('flex', classes.actionButtonContainer)}>
						<div className={classes.fullSize}>
							<ButtonNew
								htmlType="button"
								onClick={() => displayModal(REJECT_PROJECT_MODAL_MODULE_ID)}
							>
								Reject Dare
							</ButtonNew>
						</div>
					</div>
				)
			}
			{/* for now comment out. purpose - https://trello.com/c/D4AgpbYe/850-give-creators-a-remove-button-instead-of-a-pledge-button */}
			{/* removing delivered dares from our system skews our stats in a negative way */}
			{/* {isAssignee && ( */}
			{/* 	<div className={classNames('flex', classes.actionButtonContainer)}> */}
			{/* 		<div className={classes.buttonTextWrapper}>Remove dare</div> */}
			{/* 		<div className={classes.buttonWrapper}> */}
			{/* 			<Button */}
			{/* 				onClick={async () => { */}
			{/* 					const { platform, mnemonicId } = userData.creatorData */}
			{/* 					const routeMap = { */}
			{/* 						twitch: { routeId: VIEW_CREATOR_DATA_ROUTE_ID }, */}
			{/* 						youtube: { routeId: VIEW_YT_CREATOR_DATA_ROUTE_ID }, */}
			{/* 					} */}

			{/* 					await apiRequest(REMOVE_DARE, { projectId, projectUrl }) */}
			{/* 					pushRouteClient({ ...routeMap[platform], routeParams: { recordId: mnemonicId } }) */}
			{/* 				} */}
			{/* 				} */}
			{/* 			> */}
			{/* 				Remove */}
			{/* 			</Button> */}
			{/* 		</div> */}
			{/* 	</div> */}
			{/* )} */}
			{isAdmin && projectDeliveries && (
				<div className={classNames('flex', classes.actionButtonContainer)}>
					<div className={classes.buttonTextWrapper}>Feature/Unfeature Dare</div>
					<div className={classes.buttonWrapper}>
						<Button onClick={async () => {
							await apiRequest(
								isFeatured ? DELETE_FEATURED_DARE : ADD_FEATURED_DARE,
								{ projectUrl },
							)
						}}
						>
							{ isFeatured ? 'Unfeature dare' : 'Feature dare' }
						</Button>
					</div>
				</div>
			)}
		</Fragment>
	)
})
